import './App.css';
import { useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import TowersListContainer from './Components/TowersListContainer';
import TowersMapContainer from './Components/TowersMapContainer';
import MapMoveEvents from './Components/MapMoveEvents';
import Header from './Components/Header'
import useTheme  from '@mui/material/styles/useTheme';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import Json from './map.json';

const viewbox = [-114.4116, 32.5005, -125.4419, 47.1223]

const Filters = {
  "distance": null,
  "height": [],
  "collocation": null,
  "types": null,
  "rad1": [],
  "rad2": [],
  "groundSpace": null,
  "resetAll": false
}

const App = () => {
  const [data, setData] = useState(Json.features);
  const [towerFilters, setTowerFilters] = useState(Filters);
  const [map, setMap] = useState(null);
  const [searchMarker, setSearchMarker] = useState(null);
  const [highlightMarker, setHighlightMarker] = useState(null);

  const theme = useTheme();
  const onlySmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  // useEffect(() => {
  //   console.log(viewbox);
  //   map.flyToBounds([[viewbox[1], viewbox[0]], [viewbox[3],viewbox[2]]]);
  // }, [map]);




  return (
    <>
      <Header map={map} viewbox={viewbox} searchMarker={searchMarker} setSearchMarker={setSearchMarker} towerFilters={towerFilters} setTowerFilters={setTowerFilters} />
  
      {!onlySmallScreen ? (
        <>
        <div className="towersListContainer">
        <TowersListContainer map={map} data={data} setHighlightMarker={setHighlightMarker} searchMarker={searchMarker} />
      </div>
      <div className='towersMapContainer'>
        <TowersMapContainer setMap={setMap} data={data} searchMarker={searchMarker} highlightMarker={highlightMarker} towerFilters={towerFilters} />
      </div>
      </>
      ) : (
        <>
        <div className='towersMapContainerSmall'>
          <TowersMapContainer viewbox={viewbox} setMap={setMap} data={data} searchMarker={searchMarker} highlightMarker={highlightMarker} towerFilters={towerFilters} />
        </div>

        <div className="towersListContainerSmall">
          <TowersListContainer map={map} data={data} setHighlightMarker={setHighlightMarker} searchMarker={searchMarker} />
        </div>  

        </>
      )}

      {map ? <MapMoveEvents map={map} setData={setData} searchMarker={searchMarker} towerFilters={towerFilters} viewbox={viewbox} /> : null}
    </>
  );

}

export default App;
